import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import voca from 'voca';
import CopyToClipboard from 'react-copy-to-clipboard';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
const clipboardStyle = {
  cursor: 'pointer',
  padding: '4px',
  verticalAlign: 'middle',
  margin: 0,
};
export class ListCustomJSCDNs extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };

  handleCustomJsCdnDelete = (uuid) => {
    this.props.handleCustomJsCdnDelete(uuid);
  };

  viewCustomJSCDN = (customJsCdn) => {
    const { actions } = this.props;
    actions.fetchJsEditorData({
      url: customJsCdn.urlOrTag,
      uuid: customJsCdn.uuid,
      customJsCdnData: customJsCdn,
    });
  };

  renderViewJSBtn = (customJsCdn) => {
    if (customJsCdn) {
      const { urlOrTag } = customJsCdn;
      let regex = new RegExp(/^(?:https?|ftps?):\/{2}/gm);

      if (regex.test(urlOrTag)) {
        return (
          <button
            onClick={() => this.viewCustomJSCDN(customJsCdn)}
            title="View JS Content"
            className="btn btn-xs btn-theme-submit"
          >
            <i className="wb webconnect-eye"></i>
          </button>
        );
      } else {
        return (
          <button
            title="Not Supported on Tags"
            className="btn btn-xs"
            disabled
            style={{ cursor: 'not-allowed' }}
          >
            <i className="wb webconnect-eye"></i>
          </button>
        );
      }
    }
  };

  render() {
    const { customJsCdns, deleteFlag, isReadOnly } = this.props;
    return (
      <div className="row mx-auto h-70 table-responsive mt-5">
        <table className="table table-bordered table-hover table-sm table-word-break">
          <thead>
            <tr>
              <th title="Index">#</th>
              <th title="Order" style={{ width: '6%' }}>
                Order #
              </th>
              <th title="Load to Builder Canvas">Load</th>
              <th title="Location">Location</th>
              <th title="Location">Type</th>
              <th title="URL/Script Tag" className="w-50">
                URL/Script Tag
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {customJsCdns.map((customJsCdn, index) => {
              return (
                <tr key={customJsCdn.uuid} className="text-left">
                  <td className="align-middle">{index + 1}</td>
                  <td className="align-middle">{customJsCdn.sortOrder}</td>
                  <td className="align-middle">
                    <span
                      className={`badge ${
                        customJsCdn.loadToBuilder ? 'badge-primary' : 'badge-theme-danger'
                      }`}
                    >
                      {customJsCdn.loadToBuilder ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td className="align-middle">
                    <span
                      className={`badge ${
                        customJsCdn.addToHead ? 'badge-theme-danger' : 'badge-primary'
                      }`}
                    >
                      {customJsCdn.addToHead ? 'Head' : 'Body'}
                    </span>
                  </td>
                  <td className="align-middle" title={customJsCdn.urlOrTag}>
                    {customJsCdn.customType && customJsCdn.customType === 'URL'
                      ? customJsCdn.customType
                      : voca.titleCase(voca.replaceAll(customJsCdn.customType, '_', ' '))}
                  </td>
                  <td className="align-middle" title={customJsCdn.urlOrTag}>
                    <CopyToClipboard
                      text={customJsCdn.urlOrTag ? customJsCdn.urlOrTag : ''}
                      onCopy={() => {
                        if (customJsCdn.urlOrTag) {
                          this.props.copyToClipboard(customJsCdn.urlOrTag);
                        }
                      }}
                      title={'Copy to clipboard'}
                      style={clipboardStyle}
                    >
                      <span>
                        {voca.first(customJsCdn.urlOrTag, 40)}...
                        {voca.last(customJsCdn.urlOrTag, 30)}{' '}
                        <i className="webconnect webconnect-files" />
                      </span>
                    </CopyToClipboard>
                  </td>
                  <td className="text-right">
                    {this.renderViewJSBtn(customJsCdn)}
                    &nbsp;
                    <button
                      className="btn btn-xs btn-primary"
                      onClick={() =>
                        isReadOnly ? null : this.props.openCustomJSCDNForm(customJsCdn.uuid)
                      }
                      title={isReadOnly ? 'Read-Only Mode' : 'Edit URL/Script Tag'}
                      disabled={isReadOnly}
                    >
                      <i className={`wb ${drapcodeIcon('edit')}`}></i>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-xs btn-theme-delete"
                      style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                      onClick={() =>
                        deleteFlag && !isReadOnly
                          ? this.handleCustomJsCdnDelete(customJsCdn.uuid)
                          : undefined
                      }
                      title={isReadOnly ? 'Read-Only Mode' : 'Delete URL/Script Tag'}
                      disabled={isReadOnly}
                    >
                      <i className={`wb ${drapcodeIcon('delete')}`}></i>
                      {deleteFlag ? null : (
                        <>
                          &nbsp;
                          <TooltipInfo
                            title={description}
                            headerText={`Permission Disabled!`}
                            showHeader={true}
                            showArrow={true}
                          />
                        </>
                      )}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectDetail: state.projectDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCustomJSCDNs);
